import { serviceInstance as api } from "../service";

export const getDataMaster = async () => {
  const response = await api().get("/maestros");
  return response.data.result.data
};
